// FAIL-SAFE STRUCTURAL-EDGE SELECTION (defense-in-depth for the thinking map).
//
// A relationship stored in ot.workspace.relationships is a DRAWABLE structural edge ONLY when BOTH of its
// endpoints are currently legitimate PLACED structural nodes in the map. A card counts as PLACED when it is:
//   - a TWS / student-adopted PART (node_kind === "group"),
//   - a direct thesis part (under_thesis),
//   - nested under another card (parent_id),
//   - the parent of at least one card (it has children), or
//   - an answer under a question (a question_id that resolves to a real question).
// Everything else sits in the "NOT PLACED YET" tray. Its DOM node still exists (so the map's ref lookup would
// otherwise succeed), but it is NOT part of the visible structure — so a relationship touching it must not be
// rendered. This is a pure, side-effect-free mirror of the map's own placement rules; it does not fix bad
// persisted state (the backend does), it only refuses to draw an edge that no longer belongs to the structure.

export function placedNodeIdSet(items = [], questions = []) {
  const qIds = new Set((questions || []).map((q) => q.id));
  const hasChild = new Set();
  (items || []).forEach((i) => { if (i.parent_id) hasChild.add(i.parent_id); });
  const answersAQuestion = (i) => (i.question_ids || []).some((qid) => qIds.has(qid));
  const placed = new Set();
  (items || []).forEach((i) => {
    if (i.node_kind === "group" || i.under_thesis || i.parent_id || hasChild.has(i.id) || answersAQuestion(i)) {
      placed.add(i.id);
    }
  });
  return placed;
}

export function drawableRelationships(items = [], questions = [], rels = []) {
  const placed = placedNodeIdSet(items, questions);
  return (rels || []).filter((r) => placed.has(r.from_id) && placed.has(r.to_id));
}
